import { MERCHANT } from "constants/action-types";
import {
    ICollectionVersionStatus,
    ICreateCollectionVersionStatus,
    IUpdateCollectionVersionStatus,
} from "helpers/collection-version-status";
import { FluxStandardAction as Action } from "flux-standard-action";

export type ListCollectionVersionStatutesRequestAction = Action<void, { merchantId: string; collectionId?: string }>;
export const listCollectionVersionStatutesRequest = (
    merchantId,
    collectionId?
): ListCollectionVersionStatutesRequestAction => ({
    meta: { merchantId, collectionId },
    payload: undefined,
    type: MERCHANT.COLLECTION_VERSION_STATUS.LIST.REQUEST,
});

export type ListCollectionVersionStatusesCompleteAction = Action<
    ICollectionVersionStatus[] | Error,
    { merchantId: string }
>;
export const listCollectionVersionStatusesComplete = (
    collectionVersionStatutes: ICollectionVersionStatus[],
    merchantId: string
): ListCollectionVersionStatusesCompleteAction => ({
    meta: { merchantId },
    payload: collectionVersionStatutes,
    type: MERCHANT.COLLECTION_VERSION_STATUS.LIST.COMPLETE,
});

export type CreateCollectionVersionStatusRequestAction = Action<
    {
        index: number;
        collectionVersionStatus: ICreateCollectionVersionStatus;
    },
    { merchantId: string }
>;
export const createCollectionVersionStatusRequest = (
    index: number,
    collectionVersionStatus: ICreateCollectionVersionStatus,
    merchantId: string
): CreateCollectionVersionStatusRequestAction => ({
    meta: { merchantId },
    payload: {
        index,
        collectionVersionStatus,
    },
    type: MERCHANT.COLLECTION_VERSION_STATUS.CREATE.REQUEST,
});

export type CreateCollectionVersionStatusCompleteAction = Action<
    ICollectionVersionStatus[] | Error,
    { merchantId: string }
>;
export const createCollectionVersionStatusComplete = (
    payload: ICollectionVersionStatus[] | Error,
    merchantId: string
): CreateCollectionVersionStatusCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.COLLECTION_VERSION_STATUS.CREATE.COMPLETE,
});

export type UpdateCollectionVersionStatusRequestAction = Action<
    {
        index: number;
        collectionVersionStatus: IUpdateCollectionVersionStatus;
    },
    { merchantId: string }
>;
export const updateCollectionVersionStatusRequest = (
    index: number,
    collectionVersionStatus: IUpdateCollectionVersionStatus,
    merchantId: string
): UpdateCollectionVersionStatusRequestAction => ({
    meta: { merchantId },
    payload: {
        index,
        collectionVersionStatus,
    },
    type: MERCHANT.COLLECTION_VERSION_STATUS.UPDATE.REQUEST,
});

export type UpdateCollectionVersionStatusCompleteAction = Action<
    ICollectionVersionStatus[] | Error,
    { merchantId: string }
>;
export const updateCollectionVersionStatusComplete = (
    payload: ICollectionVersionStatus[] | Error,
    merchantId: string
): UpdateCollectionVersionStatusCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.COLLECTION_VERSION_STATUS.UPDATE.COMPLETE,
});

export type SortCollectionVersionStatusRequestAction = Action<
    {
        index: number;
        destinationIndex: number;
    },
    { merchantId: string }
>;
export const sortCollectionVersionStatusRequest = (
    index: number,
    destinationIndex: number,
    merchantId: string
): SortCollectionVersionStatusRequestAction => ({
    meta: { merchantId },
    payload: { index, destinationIndex },
    type: MERCHANT.COLLECTION_VERSION_STATUS.SORT.REQUEST,
});

export type SortCollectionVersionStatusCompleteAction = Action<Error | undefined, { merchantId: string }>;
export const sortCollectionVersionStatusComplete = (
    payload: Error | undefined,
    merchantId: string
): SortCollectionVersionStatusCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.COLLECTION_VERSION_STATUS.SORT.COMPLETE,
});

export type RemoveCollectionVersionStatusRequestAction = Action<
    {
        index: number;
    },
    { merchantId: string }
>;
export const removeCollectionVersionStatusRequest = (
    index: number,
    merchantId: string
): RemoveCollectionVersionStatusRequestAction => ({
    meta: { merchantId },
    payload: { index },
    type: MERCHANT.COLLECTION_VERSION_STATUS.REMOVE.REQUEST,
});

export type RemoveCollectionVersionStatusCompleteAction = Action<Error | undefined, { merchantId: string }>;
export const removeCollectionVersionStatusComplete = (
    payload: Error | undefined,
    merchantId: string
): RemoveCollectionVersionStatusCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.COLLECTION_VERSION_STATUS.REMOVE.COMPLETE,
});
